module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_twitter.f163f9c8.jpg";